import { Component, OnInit } from '@angular/core';
import { DocumentReader } from 'src/app/modules/core/store/models';
import * as fromAuth from 'src/app/modules/authentication/store/auth';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-reference-cell',
    templateUrl: './reference-cell.component.html',
    styleUrls: ['./reference-cell.component.scss'],
    standalone: false
})
export class ReferenceCellComponent implements OnInit {
  displayName: any;

  constructor() {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;

    const field = params.schemaField;
    const reader = new DocumentReader(document);

    const displayFieldName = params.displayFieldName ?? `${field.systemName}_display`;

    this.displayName = reader.getFieldValue(displayFieldName);
  }
}
